<template>
  <div class="top">
    <div
      class="bg"
      style="
        background-color: #fddc3e;
        padding: 10px;
        text-align: center;
        margin: 20px;
      "
    >
      Comiru アプリ インストール ページ
    </div>
    <el-row :gutter="20" style="margin-bottom: 10px">
      <el-col :span="6" :offset="3">プラットフォーム:</el-col>
      <el-col :span="12" :offset="0">
        <el-select v-model="valuePlatform" placeholder="">
          <el-option
            v-for="item in optionsPlatform"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-bottom: 10px">
      <el-col :span="6" :offset="3">アプリ:</el-col>
      <el-col :span="12" :offset="0">
        <el-select v-model="valueApp" placeholder="">
          <el-option
            v-for="item in optionsApp"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-bottom: 10px">
      <el-col :span="6" :offset="3">環境:</el-col>
      <el-col :span="12" :offset="0">
        <el-select v-model="valueMode" placeholder="">
          <el-option
            v-for="item in optionsMode"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row
      :gutter="20"
      style="margin-bottom: 10px"
      v-if="valuePlatform == 'ios'"
    >
      <el-link href="https://qiita.com/YokohamaHori/items/d00e1786c34b4ab30638">
        <el-button type="warning"> IOS16のお方へ </el-button>
      </el-link>
      <!-- <el-link style="margin-left:20px" href="https://developer.apple.com/documentation/xcode/enabling-developer-mode-on-a-device">
        <el-button type="warning"> Apple Official Documentation </el-button>
      </el-link> -->
    </el-row>

    <el-row :gutter="20">
      <el-col>
        <el-table :data="tableData" border style="width: 100%" stripe>
          <el-table-column fixed prop="date" label="App">
            <template slot-scope="scope">
              <el-row :gutter="20">
                <el-col :span="8" :offset="0">
                  <el-image
                    :src="
                      valueApp == 'comiru'
                        ? require('../assets/comiru.jpg')
                        : valueApp == 'comiruair'
                        ? require('../assets/comiru_air.png')
                        : require('../assets/comiru_recorder.jpg')
                    "
                    :lazy="true"
                    fit="fill"
                  ></el-image>
                </el-col>
                <el-col :span="16" :offset="0">
                  <el-row id="font-inner">
                    {{ scope.row.app_name }}
                  </el-row>
                  <el-row id="font-time">
                    {{ scope.row.version }} {{ scope.row.more_info }}
                  </el-row>
                  <el-row>
                    {{
                      new Date(scope.row.upload_timestamp * 1000)
                        .toLocaleString()
                        .split(" ")[0]
                    }}
                  </el-row>
                  <el-row>
                    {{
                      new Date(scope.row.upload_timestamp * 1000)
                        .toLocaleString()
                        .split(" ")[1]
                    }}
                  </el-row>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Download" width="120">
            <template slot-scope="scope">
              <el-button
                size="small"
                style="background-color: #fddc3e; text-align: center"
              >
                <a
                  v-if="valuePlatform == 'ios'"
                  :href="handleUrl(scope.row)"
                  @click="handleClick(scope.row)"
                  >ダウンロード</a
                >
                <a v-else download :href="handleUrl(scope.row)">ダウンロード</a>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <footer>問題があれば、郭（カク）に連絡ください</footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      optionsPlatform: [
        {
          value: "ios",
          label: "iOS",
        },
        {
          value: "android",
          label: "Android",
        },
        {
          value: "mac",
          label: "Mac",
        },
        {
          value: "windows",
          label: "Windows",
        },
      ],
      optionsApp: [
        {
          value: "comiru",
          label: "Comiru",
        },
        {
          value: "comirurecorder",
          label: "ComiruRecorded",
        },
        {
          value: "comiruair",
          label: "ComiruAir",
        },
        {
          value: "comiruim",
          label: "ComiruIM",
        },
        {
          value: "schoolbus",
          label: "スクールバス",
        },
      ],
      optionsMode: [
        {
          value: "stage",
          label: "staging",
        },
        {
          value: "prod",
          label: "本番",
        },
        {
          value: "others",
          label: "others",
        },
      ],
      valueApp: "comiru",
      valueMode: "stage",
      valuePlatform: "ios",
      tableData: [],
    };
  },
  watch: {
    valueApp(oldV, newV) {
      this.getList();
    },
    valueMode(oldV, newV) {
      this.getList();
    },
    valuePlatform(oldV, newV) {
      this.getList();
    },
  },
  async mounted() {
    this.valuePlatform = this.appSource();
    this.getList();
  },
  methods: {
    async getList() {
      // var api = "http://localhost:8000/getList/";
      var api = "https://distribution.comiru.com/api/getList/";
      var data_map = {};
      if (this.valueApp != null && this.valueApp != "") {
        data_map["app_name"] = this.valueApp;
      }
      if (this.valueMode != null && this.valueMode != "") {
        data_map["mode"] = this.valueMode;
      }
      if (this.valuePlatform != null && this.valuePlatform != "") {
        data_map["platform"] = this.valuePlatform;
      }
      data_map["expired"] = false;
      this.axios
        .get(api, {
          params: data_map,
        })
        .then((response) => {
          console.log(response.data);
          this.tableData = response.data.data;
        });
    },
    handleClick(data) {
      this.log("download " + this.valuePlatform + data.path);
    },
    handleUrl(data) {
      var path = data.path;
      var url = "https://distribution.comiru.com" + path.replace("/file", "");
      if (this.valuePlatform == "ios") {
        var middle = path.replace("/file", "").split("/");
        var tempUrl = "";
        for (var i = 0; i < middle.length - 1; i++) {
          tempUrl = tempUrl + middle[i] + "/";
        }
        url =
          "itms-services://?action=download-manifest&url=https://distribution.comiru.com" +
          tempUrl +
          "manifest.plist";
      }
      return url;
    },
    log(info) {
      var api = "/addLog/";
      this.axios
        .post(
          api,
          this.$qs.stringify({
            info: info,
            action: "download",
          })
        )
        .then((response) => {
          console.log(response);
          this.getList();
        });
    },
    appSource() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        return "ios";
      } else {
        return "android";
      }
    },
  },
};
</script>

<style scope>
bg {
  color: #493b32;
  background-color: #fddc3e;
  width: 100%;
}
#font-inner {
  font-size: large;
  font-optical-sizing: auto;
  font-weight: bold;
}
#font-time {
  font-size: medium;
}
</style>
